import { useMemo } from 'react';

import { useAppSelector } from '@/app/store/hooks';
import { NOTIFICATION_POLL_INTERVAL_MS } from '@/config/notificationConfig';

import type { FrontendConfigItem } from './useFrontendCacheConfig';

export function useNotificationConfig(): { pollIntervalMs: number } {
    const frontend = useAppSelector((state) => state.cache.frontend) as FrontendConfigItem[];

    return useMemo(() => {
        const index: Record<string, string> = {};
        if (frontend?.length) {
            for (const item of frontend) {
                if (item?.cd) index[item.cd] = item.dsc;
            }
        }

        const pollIntervalMs = index['application.notification.pool.interval']
            ? Number(index['application.notification.pool.interval']) * 1000
            : NOTIFICATION_POLL_INTERVAL_MS;

        return { pollIntervalMs };
    }, [frontend]);
}
